import { IPart } from "../../../models/Part";
import UnlistedOfferPrice from "./UnlistedOfferPrice";
import UnlistedStockSummaryCell from "./UnlistedStockSummaryCell";

type Props = { part: IPart };

/**
 * Unlisted table column: price tile on top, stock summary tile below.
 */
export default function UnlistedPriceStockCell({ part }: Props) {
  return (
    <div
      className="flex h-full min-w-0 max-w-xs flex-col gap-2"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="rounded-xl border border-slate-200/90 bg-gradient-to-b from-slate-50/95 to-white p-2 shadow-sm ring-1 ring-slate-200/50">
        <UnlistedOfferPrice
          part={part}
          hideLabel
          showButtons
          compact
          buttonLayout="column"
        />
      </div>

      <div className="flex flex-1 min-h-0">
        <UnlistedStockSummaryCell part={part} />
      </div>
    </div>
  );
}
